// /var/www/website2024/dev.afaa.website/s-293-spatime-dev/src/utilities/dateUtils.js

export const formatDateForSubmission = (dateString) => {
    const [month, day, year] = dateString.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };
  